export const ID_PFR_HIGHLIGHT = 'position-fill-requests';

export const POSITION_FILL_REQUESTS_PATH = '/position-fill-requests';

export const POSITION_FILL_REQUEST_STATUS = {
  REQUESTED: 'REQUESTED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ACTIVE: 'ACTIVE',
  ALLOCATED: 'ALLOCATED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
} as const;

export type PositionFillRequestStatus =
  (typeof POSITION_FILL_REQUEST_STATUS)[keyof typeof POSITION_FILL_REQUEST_STATUS];

export const POSITION_FILL_REQUEST_READ = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_READ';
export const POSITION_FILL_REQUEST_SEARCH = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_SEARCH';
export const POSITION_FILL_REQUEST_CREATE = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_CREATE';
export const POSITION_FILL_REQUEST_UPDATE = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_UPDATE';

export const POSITION_FILL_REQUEST_CANCEL = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_CANCEL';
export const POSITION_FILL_REQUEST_REVIEW = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_REVIEW';
export const POSITION_FILL_REQUEST_ACTIVE = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_ACTIVE';

export const POSITION_FILL_REQUEST_GET_WORK_INDICATOR = 'RECRUITING_POSITION_FULFILLMENT_REQUEST_GET_WORK_INDICATOR';
